import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function challenge() {
  return (
    <section className="challenge-serve-easy case-about-sec case-about-left">
      <Container>
        <Row className="align-items-center justify-content-between flex-md-row flex-column-reverse">
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={6}
            className=""
          >
            <div className="image text-md-start text-center">
              <StaticImage
                src="../../../images/case-studies/serve-easy/challenge.webp"
                alt="The Challenge"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={657}
                height={816}
              />
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-md-0 mb-4">
            <div class="content">
              <h2>
                The Challenge
              </h2>
              <p>The client sought to develop a robust cloud-based POS system that could seamlessly integrate Restaurant POS, Online Ordering, and Kitchen Display System functionalities. The primary challenge was to build a unified platform that could handle complex operations across multiple outlets with smooth, real-time data synchronization.</p>
            </div>
          </Col>
          
        </Row>
      </Container>
    </section>
  );
}

export default challenge;
